//**************************************************************
import { 
          Component,
          Inject,
          ViewChild 
        } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../../src/environments/environment';
//**************************************************************
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef }       from '@angular/material/dialog';
import { RegistrationLoginModal }                         from '../comlogin/comloginclass';
//**************************************************************
// Firestore 
import { firestorecontrol }                               from "../../appfirestore/app.firestore";
//**************************************************************
// Functions
import { appfunctions  }                                  from '../../functions/app.functions';
//**************************************************************
import { ConfirmationStripeModal }                        from '../comstripepayment/stripepaymentmodal';
import { ComstripepaymentComponent }                      from '../comstripepayment/comstripepayment.component';
//**************************************************************
@Component(
              {
                  selector: 'app-comlogin',
                  templateUrl: './comlogin.component.html',
                  styleUrls: ['./comlogin.component.scss']
              }
          )
//**************************************************************
export class ComloginComponent 
  {
    // Login Details
    logintype: number = 0;

    // Login or Registration
    // Common Parameters
    eventname:            string = '';
    email:                string = '';  // Live
    password:             string = '';  // Live
    eventcost:            number = environment.eventplannercost;

    passwordreset:        string = '';
    passwordconfirm:      string = '';
    passwordcurrent:      string = '';
    passwordMode:         string = '';
    passwordModeconfirm:  string = '';
    passwordlabel:        string = 'Password';

    passwordButton:           any;
    passwordButtonConfirm:    any;

    btndisable:           boolean = true;
    inputdisable:         boolean = false;
    checkBoxValue:        boolean | null | undefined
    checkBoxVisible:      boolean = true;
    resetPasswordconfirm: boolean  | null | undefined
    closeLoginBox:        boolean = true;
    btnconfirmvisible:    boolean = true;

    // Email Validation
    emailPattern: any = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    
    // Toast Messages
    toastFileMessage: string = '';
    toastVisible: boolean = false;
    toasttypeerror: string = 'error';
    toastdisplaytime: number = 3000;
    toastwidth: string = '240';
    settoastwidth: string = '240';


    //**************************************************************
    constructor ( 
                  private firestoredata: firestorecontrol, 
                  private appfunction: appfunctions,
                  private dialogRef:  MatDialogRef<ComloginComponent>,
                  private dialog: MatDialog,
                  @Inject( MAT_DIALOG_DATA ) public data: RegistrationLoginModal
                ) 
      { 
          //**************************************************************
          // 10=Registration # 20=Login
          this.logintype = data.registerOrLogin;
          //**************************************************************
          
          this.resetPasswordconfirm = false;
          this.passwordMode         = 'password';

          this.passwordButton = {
                                    icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=',
                                    type: 'default',
                                    onClick: () =>  {
                                                      this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
                                                    }
                                };


          this.passwordModeconfirm = 'password';                       
          this.passwordButtonConfirm = {
                                          icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=',
                                          type: 'default',
                                          onClick: () =>  {
                                                            this.passwordModeconfirm = this.passwordModeconfirm === 'text' ? 'password' : 'text';
                                                          },
                                };
          //**************************************************************

      }
    //**************************************************************
    ngOnInit(): void 
      {
            // console.log( this.logintype )
            //----------------------------------------------------------------
            // Test - to be commented out when in production

            switch ( this.logintype )
              {
                case 10:  // Registration of Event
                  {
                    this.btnconfirmvisible = false;
                    break;
                  }

                case 20:  // Login
                  {
                    this.email       = 'yes@keyinfo.com';     // test - event organiser
                     this.password   = 'qwertyui';  // test - event organiser

                  //  this.email      = 'ashley.seeto@outlook.com';     // test - administrator
                  //  this.password   = 'HannWing88';                   // test - administrator
                    break;
                  }
              }
            //---------------------------------------------------------------- 
      }
    //**************************************************************  
    passwordComparison = () =>
      {
        return this.password;
      };
    //**************************************************************
    async loginstatus( event: any, whatoption: number, sellogintype: number )  
      {
       
        let result = event.validationGroup.validate();     
    
        if ( whatoption == 1 ) // whatoption 1 = Confirm Button = was clicked. whatoption = 0 = Cancel Button = was clicked.
          {
            // Has passed all validation
            if  ( result.isValid )
              {
                this.closeLoginBox = true;
                //**************************************************************
                // Create & Storing Values for Login Form
                // Based Login Values
                switch ( sellogintype )
                  {
                    //----------------------------------------------------------------
                    // Registration - New Event
                    case 10:
                      {
                        this.data.closestatus            = true;                // Confirm button was selected
                        this.data.registerOrLogin        = sellogintype;        // Registration = 10 Login = 20
                        this.data.eventid                = this.data.eventid 
                        this.data.eventname              = this.eventname;
                        this.data.selpassword            = this.password;
                        this.data.selemail               = this.email;
                        this.data.loginstatus            = false;               // loginstatus will confirm true when firstore set is confirmed
                        this.data.errorcode              = 0;
                        this.data.stripestatus           = this.data.stripestatus;
                        this.data.stripetoken            = this.data.stripetoken
                        this.data.spare                  = 0;
                        break;
                      }
                    //----------------------------------------------------------------  
                    // Login - Existing
                    case 20:
                      {
                        this.data.closestatus            = true;                // Confirm button was selected
                        this.data.registerOrLogin        = sellogintype;        // Registration = 10 Login = 20
                        this.data.eventid                = 'TBC';
                        this.data.selpassword            = this.password;
                        this.data.selemail               = this.email;
                        this.data.loginstatus            = false;    
                        this.data.errorcode              = 0;
                        this.data.spare                  = 0;
                        break;
                      }
                    //----------------------------------------------------------------
                    }
                //**************************************************************
                // Not applicable to Register Event
                if ( this.resetPasswordconfirm  == true )
                  {
                    this.data.selpassword = this.passwordcurrent; 
                  }
                //**************************************************************
                // Validate status Email + Password + Stripe Payment Statusin collection Event
                let validparticipant = await this.firestoredata.isSignInValid   (   
                                                                                  this.data.selemail,
                                                                                  this.data.selpassword                                                           
                                                                                );   
                //**************************************************************
                //  sellogintype
                // 10 - Registering New Event
                // 20 - Login Existing Event                                                              
                switch ( sellogintype )
                  {  
                      //**************************************************************
                      // Registration    
                      // For Registrations for loginstatus = true. Must have
                      // 01. There is no existing combination of email & password
                      // 02. There must a valid Stripe Payment Confirmation
                      // Start Phase - Confirm - is disabled
                      // Enter:
                      // 01. Enter Event Name, Email, Password & Confirm Password
                      // 02. Register Payment  - Stripe Payment Popup + Validation Check on Point 01 & 02. Lock 01 & 02
                      // 03  If Stripe Payment Confirm than SAVE to Firestore than close     
                      // Error Code 
                      // 0    = Login Cancel 
                      // 100  = Register Event - Login Detail & Stripe Payment is Successful 
                      // 200  = Register UnSuccessful                                                  
                      case 10:  
                        {
                          // Default errorcode 
                          this.data.errorcode   = 100;

                          break; 
                        }
                      //**************************************************************
                      // Login
                      // For Login for loginstatus = true. Must have
                      // 01. There must be combination of email & password
                      // 02. There must a valid Stripe Payment Confirmation
                      // Error Code 
                      // 0    = Login Cancel
                      // 100  = Login Successful
                      // 120  = Login & Password Reset Successful
                      // 200  = Login UnSuccessful                                                             
                      case 20:  
                        {
                          // Default errorcode
                          this.data.errorcode   = 200;

                          // Username + Password Validate for Event Participants
                          // Stripe Payment has registered
                          if ( validparticipant[0].recsize == 1 && validparticipant[0].stripestatus == true )
                            {
                              // Reset Password Requested
                              if ( this.checkBoxValue == true )
                                {
                                  
                                  this.closeLoginBox             = false;

                                  // Makes Password Reset Confirm Enable
                                  this.resetPasswordconfirm     = true;
                                  this.passwordlabel            = 'Reset Password';

                                  // Reset password and passwordreset = ''
                                  this.passwordcurrent    = this.password; // Current Password
                                  this.password           = ''
                                  this.passwordreset      = '';
                                  // Hide Reset CheckBox 
                                  this.checkBoxVisible    = false;
                                  this.checkBoxValue      = false

                                }
                              else
                                {
                                    this.data.eventid       = validparticipant[0].eventid;
                                    this.data.loginstatus   = true;   // Valid Login - email & password
                                    this.data.errorcode     = 100;

                                    // If Reset Password option was selected
                                    if (  this.resetPasswordconfirm == true ) 
                                      {
                                        this.closeLoginBox          = true; // Status
                                        this.resetPasswordconfirm   = false;
                                        
                                        // Update Profile
                                        this.data.newpassword = this.passwordconfirm;
                                        this.data.errorcode     = 120; // Code for Reset Password
                                      }
                                }
                            }
                          else
                            {
                              //----------------------------------------------------------------
                              // Validate whether Login -> Email / Password is a Administrator
                              let validparticipant = await this.firestoredata.isAdminSignInValid   (   
                                                                                                      this.data.selemail,
                                                                                                      this.data.selpassword                                                           
                                                                                                    );   

                              if ( validparticipant[0].recsize == 1  )
                                {
                                  this.data.eventid       = validparticipant[0].eventid;
                                  this.data.loginstatus   = true;   
                                  this.data.errorcode     = 110;
                                  this.data.spare         = 0;
                                  
                                  this.closeLoginBox      = true; // Status
                                
                                }
                              //----------------------------------------------------------------




                            }  
                          
                          break; 
                        }

                  }
                //**************************************************************
                if ( this.closeLoginBox )
                  {
                    setTimeout  ( () => {
                                          this.data.closestatus = true;
                                          this.dialogRef.close( this.data );
                                        },
                                        1000  
                                )   
                  }   
               //**************************************************************                     
              }
          }
        else
          {
            // Cancel 
            setTimeout( () => {
                                this.data.closestatus = false;
                                this.dialogRef.close( this.data );
                              },
                              500
                      )
          }
      }
    //**************************************************************
    closedialog( event: any )
      {
        // Close dialogue Baox
        this.dialogRef.close( this.data );
      }
    //**************************************************************  
    // Register Event & Payment on Stripe   
    async paymentstripe( event: any, whatoption: number, sellogintype: number )
      {
        var stripepaymentstatus: boolean = false;

        let result = event.validationGroup.validate();
        //**************************************************************
        // Has inputs passed all validation
        if  ( result.isValid )
          {
            //**************************************************************
            // Validate whether there is an existing event with the same 
            // email and password 
            // Must be 0
            let validparticipant = await this.firestoredata.isSignInValid 
              (   
                this.email,
                this.password                                                           
              );   
            //**************************************************************
            // Initiate Stripe Payment Form
            if ( validparticipant[0].recsize == 0 )    
              {
                //**************************************************************
                // Validate whether Stripe Payment has been successful
                // stripepaymentstatus = false;
                // Create Stripepayment Card

                // Stripe Payment Dialog Box Parameters
                const dialogData = new ConfirmationStripeModal( 
                                                                false,            // closestatus = true(success) or false(failed)
                                                                1,                // Payment Type  = 1 Registration of Event
                                                                this.eventcost,   // Event Planner Amount
                                                                1,                // Service Percentage - Not Applicable
                                                                this.email,       // Customer Email 
                                                                this.password,    // Customer Password
                                                                this.eventname,   // Event Name
                                                                'TBC'
                                                              );
                //**************************************************************  
                // Open Stripe Payment Dialog Form
                const dialogRef = this.dialog.open(  ComstripepaymentComponent, // Component
                                                          {
                                                            height: '300px',
                                                            width:  '600px',

                                                            position: {
                                                                        top: '5%',
                                                                        left: '40%'
                                                                      },

                                                            disableClose: true,
                                                            
                                                            closeOnNavigation: true,
                                                            data: dialogData           // data being passed to Dialog Box
                                                          }
                
                                                  )
                //**************************************************************
                // Close Stripe Payment Dialog Form - Results                                    
                dialogRef.afterClosed().subscribe(  dialogResult => {

                                                                     // console.log( dialogResult )
                                                                      if ( dialogResult.closestatus ) 
                                                                        {      
                                                                          // Success Stripe Payment and Registration
                                                                          //  console.log('Success Stripe Payment')

                                                                          // Close Login Form
                                                                          setTimeout( () => {

                                                                                                this.data.closestatus = true;
                                                                                                this.data.loginstatus = true;
                                                                                                this.data.errorcode   = 100;   // Success Stripe Payment and Firestore Registration
                                                                                                this.data.eventid     = dialogResult.eventid;
                                                                                                this.data.selemail    = this.email;
                                                                                                this.data.selpassword = this.password;

                                                                                                this.dialogRef.close( this.data ); // Close Login & Registration Form
                                                                                                
                                                                                            },
                                                                                            5000

                                                                                    );
          
                                                                        }
                                                                      else
                                                                        {
                                                                          // Failed




                                                                          //console.log( 'cancel')
                                                                        }
                                                                    }
                                                    );

              }                                                   
           else
              {
                
                this.settoastwidth = (+this.settoastwidth + 60).toString();

                this.toastFileMessage ='Email and Password already registered '
                this.toasttypeerror   = 'error';
                this.toastdisplaytime = 5000;
                this.toastwidth       = this.settoastwidth ;
                this.toastVisible     = true;

              }
            //*************************************************************
          }  
        //**************************************************************
      }
    //**************************************************************
  }